/** Custom error classes for Experiments module matching API contract */
/** 400 - Bad Request */
export class ExperimentBadRequestError extends Error {
    constructor(message) {
        super(message);
        this.code = 400;
        this.name = "ExperimentBadRequestError";
    }
}
/** 404 - Not Found (Experiment) */
export class ExperimentNotFoundError extends Error {
    constructor(experimentId) {
        super(`Experiment with ID ${experimentId} not found`);
        this.code = 404;
        this.name = "ExperimentNotFoundError";
    }
}
/** A configuration-meta API response violates the wire contract (e.g. an
 * unrecognized enum value, or a trigger with both/neither of values and
 * match_any) and cannot be represented as valid metadata. */
export class ConfigurationMetaValidationError extends Error {
    constructor(message) {
        super(message);
        this.name = "ConfigurationMetaValidationError";
    }
}
//# sourceMappingURL=errors.js.map